import { executeRequest, JFSRequest } from '@jfs/network'
import { RootStore } from '../data/store'
import { isSuccessResponse } from '../utils'
import { APIEndPoints } from './APIEndPoints'
import { getHeaders, getUrl, sitConfig } from './config'

const responseParser = (response: any) => {
  console.log('response=', response)
  const data = isSuccessResponse(response)
  console.log('data=', data)
  return data
}

const entityConfigApprovalActionApi = (taskInstanceId, opsCheckerActionType: any) => {
  const request: JFSRequest<{}> = {
    apiPath: getUrl(APIEndPoints.entityConfigApprovalActionApi) + taskInstanceId + '/complete',
    method: 'POST',
    cache: false,
    config: sitConfig(RootStore.session.getTokens),
    headers: getHeaders(),
    body: { opsCheckerActionType },
  }

  return executeRequest(request)
    .then(responseParser)
    .catch((error) => {
      throw error
    })
}

export { entityConfigApprovalActionApi }
